/**
 * bleeme-page-drawer
 *
 * Opens policies and selected info pages in the theme's own drawer instead of
 * navigating to a full page. Content is fetched on first use via the Section
 * Rendering API and cached for the rest of the session.
 *
 * Markup: snippets/bleeme-page-drawer.liquid
 * Source: sections/bleeme-page-drawer.liquid
 *
 * Links opt in either by pointing at /policies/ or by carrying the
 * data-page-drawer attribute (set in snippets/footer-menu.liquid).
 */
(() => {
  const DRAWER_ID = 'PageDrawer';
  const SECTION_ID = 'bleeme-page-drawer';

  // Muss einen echten Policy-Handle treffen. Der Footer enthaelt auch
  // /policies/#shopifyReshowConsentBanner, das den Cookie-Banner wieder
  // oeffnet und keine Seite ist.
  const POLICY_PATH = /\/policies\/[a-z0-9]+[a-z0-9-]*/i;

  const cache = new Map();

  const isPlainLeftClick = (event) =>
    event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;

  const isDrawerLink = (link) => {
    if (!link || link.target === '_blank') return false;

    const href = link.getAttribute('href');
    if (!href || href.startsWith('#')) return false;

    return link.hasAttribute('data-page-drawer') || POLICY_PATH.test(href);
  };

  const fetchContent = async (url) => {
    if (cache.has(url)) return cache.get(url);

    const separator = url.includes('?') ? '&' : '?';
    const response = await fetch(`${url}${separator}section_id=${SECTION_ID}`);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
    const payload = parsed.querySelector('.bleeme-page-drawer__payload');
    if (!payload || payload.innerHTML.trim() === '') throw new Error(`Kein Inhalt fuer ${url}`);

    const content = {
      title: payload.getAttribute('data-drawer-title') || '',
      html: payload.innerHTML
    };

    cache.set(url, content);
    return content;
  };

  const openDrawer = async (url, link) => {
    const drawer = document.getElementById(DRAWER_ID);
    if (!drawer || typeof drawer.show !== 'function') {
      window.location.href = url;
      return;
    }

    link.setAttribute('aria-busy', 'true');

    try {
      const { title, html } = await fetchContent(url);

      drawer.querySelector('[data-drawer-title]').textContent = title;
      drawer.querySelector('[data-drawer-content]').innerHTML = html;
      drawer.show(link);
    } catch (error) {
      console.error('bleeme-page-drawer:', error);
      window.location.href = url;
    } finally {
      link.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('click', (event) => {
    if (!isPlainLeftClick(event)) return;

    const link = event.target.closest('a[href]');
    if (!isDrawerLink(link)) return;

    event.preventDefault();
    openDrawer(link.getAttribute('href'), link);
  });
})();
